//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "marionette",
  "messaging/messenger",
  "./taskUploadsView",
  "modules/upload/contentUploadModel",
], function (Marionette, Messenger, TaskUploadsView, ContentUploadModel) {
  "use strict";

  const TaskUploadsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "taskUploads";
      this.region = options.region;
      this.allowAdd = options.allowAdd;
      this.allowDelete = options.allowDelete;
      this.allowUpdate = options.allowUpdate;
    },
    show: function (task, taskUploads) {
      this.task = task;
      this.taskUploads = taskUploads;
      taskUploads.allowAdd = this.allowAdd;
      taskUploads.allowDelete = this.allowDelete;
      taskUploads.allowUpdate = this.allowUpdate;
      this.view = new TaskUploadsView.taskUploadsView({
        collection: taskUploads,
      });
      this.view.on("add:upload", this._onAddUpload, this);
      this.view.on("itemview:delete:upload", this._onDeleteUpload, this);
      const downloadCookie = Messenger.reqres.request("get:download:cookie");
      this.showRegion(this.view, {
        loading: true,
        entities: [taskUploads, downloadCookie],
      });
    },
    _onAddUpload: function (file, form) {
      if (!file || !form) {
        return;
      }
      // NOTE: The input for the template already includes accept="text/html" so the browser should already
      // limit uploads to HTML files.
      const fileName = file.name;
      const fileSize = file.size;
      if (fileSize > ContentUploadModel.contentUpload.MAX_SIZE) {
        Messenger.okDialog("content.dialog.tooLarge");
        console.log("File size exceeds maximum allowed");
        return;
      }
      //upload the file to the upload server
      const uploadModel = new ContentUploadModel.contentUpload({
        kbId: this.task.get("kbId"),
        // This is specifically not tied to any particular language or touchpoint
      });
      Messenger.vent.once(
        "content:upload:changed",
        function (isSuccess, fileName, fileSize, isUploaded, uploadId) {
          if (isSuccess) {
            const data = {
              uploadFileName: fileName,
              uploadId: uploadId,
              uploadUrl: Messenger.reqres.request("get:download:url", uploadId, fileName),
            };
            if (!this.task.isNew()) {
              data.taskId = this.task.get("id");
            }
            this.taskUploads.addItem(data);
          }
        },
        this,
      );
      Messenger.reqres.request("upload:content", form, fileName, fileSize, uploadModel);
    },
    _onDeleteUpload: function (itemView) {
      Messenger.yesNoDialog("task.uploads.confirmDelete", {
        yes: () => {
          Messenger.vent.trigger("track:interaction", {
            action: "Delete Task Upload",
            id: itemView.model.id,
            idType: "Task Upload",
            object: "Task Upload",
          });
          this.taskUploads.remove(itemView.model);
          // Do not use deleteModel(), because the uploads are handled as part of the overall task
          Messenger.vent.trigger("cancel:textbox");
        },
      });
    },
  });

  return TaskUploadsController;
});
